import { propIs } from 'utils';

import { ILegacyCartEntry } from '@rbi-ctg/menu';
import { IsCartEntryType } from 'state/menu/types';
import { CartEntryType } from 'utils/cart/types';

export const isCartEntryCombo = () => propIs<ILegacyCartEntry>('type', CartEntryType.combo);

export const isCartEntryWithTypeCombo = isCartEntryCombo() as IsCartEntryType<ILegacyCartEntry>;
